import { Injectable } from '@angular/core';
import { createStore, withProps } from '@ngneat/elf';
import { DEFAULT_CHART } from '#common/constants/mconfig-chart';
import { EMPTY_REPORT_ID } from '#common/constants/top';
import { makeCopy } from '#common/functions/make-copy';
import type { ReportX } from '#common/zod/backend/report-x';
import { BaseQuery } from './base.query';

export type ReportState = ReportX;

export const emptyReport: ReportState = {
  projectId: undefined,
  structId: undefined,
  reportId: EMPTY_REPORT_ID,
  draft: false,
  creatorId: undefined,
  filePath: undefined,
  title: 'New Report',
  space: undefined,
  accessRoles: [],
  accessRolesCombined: [],
  fields: [],
  extendedFilters: [],
  timezone: undefined,
  timeSpec: undefined,
  timeRangeFraction: undefined,
  rangeStart: undefined,
  rangeEnd: undefined,
  metricsStartDateYYYYMMDD: undefined,
  metricsEndDateExcludedYYYYMMDD: undefined,
  metricsEndDateIncludedYYYYMMDD: undefined,
  timeColumnsLength: undefined,
  timeColumnsLimit: undefined,
  isTimeColumnsLimitExceeded: false,
  rows: [],
  chart: makeCopy(DEFAULT_CHART),
  columns: [],
  draftCreatedTs: undefined,
  serverTs: undefined,
  canEditOrDeleteReport: undefined,
  author: undefined
};

@Injectable({ providedIn: 'root' })
export class ReportQuery extends BaseQuery<ReportState> {
  constructor() {
    super(createStore({ name: 'report' }, withProps<ReportState>(emptyReport)));
  }
}
